var Backlink = function () {
    var backLink = document.querySelector('.js-backlink');

    if (!backLink) {
        return;
    }

    if (document.referrer && document.referrer !== window.location.href) {
        backLink.setAttribute('href', document.referrer);
    }

    backLink.addEventListener('click', function (e) {
        if (window.history.length > 1) {
            e.preventDefault();
            window.history.back();
        }
    });
};

export default Backlink;
